module.exports = __webpack_public_path__ + "img/contribution-planner-calc.870416fd.svg";